export function jump(path, save) {
  this.path_to = path
  if (save) {
    localStorage.setItem('activeurl', path)
  }
  this.$router.push({
    path: path
  })
}



//////////////////
// WEBPACK FOOTER
// ./static/function.js
// module id = null
// module chunks = 